import cache from 'helpers/cache';

function expression() {
    this.cache = new cache({
        type: 'temp'
    });
    this._init();
};

function initExpression(expression) {
    expression.prototype._init = function () {
        var self = this;
        var innerSelf = {};
        self.analycache = [];
        /**
         * 判断是否需要下一步分析
         */
        innerSelf.hasNextAnaly = function (char) {
            if (char === '.')
                return true;
            return false;
        };
        /**
         * 分析是否存在多字段（,）
         */
        innerSelf.analyMutilFiled = function (expr) {
            var arr = expr.split('');
            var temp = '';
            var isNextAnaly = false;
            var results = [];
            for (var i = 0; i < arr.length; i++) {
                if (!isNextAnaly)
                    isNextAnaly = innerSelf.hasNextAnaly(arr[i]);
                if (arr[i] === ',') {
                    if (temp.length === 0)
                        continue;
                    results.push({
                        field: temp,
                        isNextAnaly: isNextAnaly
                    });
                    isNextAnaly = false;
                    temp = '';
                } else {
                    temp += arr[i];
                }
                if (i === arr.length - 1) {
                    results.push({
                        field: temp,
                        isNextAnaly: isNextAnaly
                    });
                }
            }
            return results;
        };
        /**
         * 分析层级字段（.）
         */
        innerSelf.analyPoint = function (filed) {
            var arr = filed.split('');
            var temp = '';
            var result = [];
            for (var i = 0; i < arr.length; i++) {
                if (arr[i] === '.') {
                    if (temp.length === 0)
                        continue;
                    result.push(temp);
                    temp = '';
                } else {
                    temp += arr[i];
                }
                if (i === arr.length - 1) {
                    result.push(temp);
                }
            }
            return result;
        };
        /**
         * 绑定语法逻辑分析,
         */
        self.analy = function (expr) {
            if (self.cache.haskey(expr))
                return self.cache.get(expr);
            var result = [];
            var fields = innerSelf.analyMutilFiled(expr);
            for (var i = 0; i < fields.length; i++) {
                if (!fields[i].isNextAnaly) {
                    result.push({
                        cols: [fields[i].field]
                    });
                } else {
                    var arr = innerSelf.analyPoint(fields[i].field);
                    result.push({
                        cols: arr
                    });
                }
            }
            self.cache.force(expr, result);
            return result;
        };
        self.getvalue = function (obj, expr) {
            let expressionStr = self.analy(expr);
            var isArrResult = expressionStr.length > 1;
            var result = isArrResult ? [] : null;
            for (var i = 0; i < expressionStr.length; i++) {
                var fieldResult = null;
                for (var j = 0; j < expressionStr[i].cols.length; j++) {
                    if (expressionStr[i].cols[j] === "$index") {
                        fieldResult = obj;
                        continue;
                    }
                    if (!fieldResult) {
                        fieldResult = obj[expressionStr[i].cols[j]];
                    } else {
                        fieldResult = fieldResult[expressionStr[i].cols[j]];
                    }
                }
                if (isArrResult && result) {
                    result.push(fieldResult);
                } else {
                    result = fieldResult;
                }
            }
            return result;
        };
        self.setvalue = function (obj, val, expr) {
            var expressionStr = self.analy(expr);
            var values = val;
            if (!(val instanceof Array)) {
                values = [];
                for (var k = 0; k < expressionStr.length; k++) {
                    values.push(val);
                }
            }
            for (var i = 0; i < expressionStr.length; i++) {
                var fieldResult = null;
                for (var j = 0; j < expressionStr[i].cols.length; j++) {
                    if (j === expressionStr[i].cols.length - 1) {
                        fieldResult[expressionStr[i]] = val[i];
                    } else
                        fieldResult = fieldResult[expressionStr[i]];
                }
            }
        };
    };
}

initExpression(expression);

export default expression;



// WEBPACK FOOTER //
// ./src/helpers/expression.js